export enum UserRole {
  ADMIN = 'admin',
  CONSUMER = 'consumer',
}

export enum Zone {
  SE = 'SE',  // South East
  SW = 'SW',  // South West
  MG = 'MG',  // Mid Ghana
  N = 'N',    // Northern
}

export const ZoneLabels: Record<Zone, string> = {
  [Zone.SE]: 'South East',
  [Zone.SW]: 'South West',
  [Zone.MG]: 'Mid Ghana',
  [Zone.N]: 'Northern',
};

export interface User {
  _id: string;
  email: string;
  firstName: string;
  lastName: string;
  role: UserRole;
  isActive: boolean;
  profileImage?: string;
  phoneNumber?: string;
  createdAt: string;
  updatedAt: string;
  // Consumer-specific fields
  campus?: string;
  zone?: Zone;
  // Admin-specific fields
  title?: string;
  addedBy?: {
    _id: string;
    firstName: string;
    lastName: string;
  };
}

export interface AuthResponse {
  accessToken: string;
  refreshToken: string;
  user: User;
}

export interface LoginCredentials {
  email: string;
  password: string;
}

export interface SignupCredentials {
  email: string;
  password: string;
  firstName: string;
  lastName: string;
  profileImage?: File;
  campus?: string;
  zone?: Zone;
  phoneNumber?: string;
}

export interface CreateAdminData {
  email: string;
  password: string;
  firstName: string;
  lastName: string;
  title?: string;
  phoneNumber?: string;
}
